var $3a9a3d180c3145c0$exports = {};
$3a9a3d180c3145c0$exports = {
  "Clear search": "\u691C\u7D22\u3092\u30AF\u30EA\u30A2"
};
export { $3a9a3d180c3145c0$exports as default };